/* eslint-disable no-shadow */
import sharedSportradar from './shared';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

const state = () => ({
  ...sharedSportradar.state(),
});
const getters = {
  ...sharedSportradar.getters,
  templateMappedPaths(state, getters) {
    return {
      teamStats: {
        teamLogo: getters.hasLogoPermission ? 'teamLogo' : false,
        teamName: 'Team.teamName',
        teamColorOne: 'Team.teamColorPrimary',
        teamColorTwo: 'Team.teamColorSecondary',
      },
      playerStats: {
        teamLogo: getters.hasLogoPermission ? 'images.teamLogo' : false,
        teamConference: 'Team.Conference.conferenceAlias',
        playerName: 'Player.fullName',
        teamColorOne: 'Team.teamColorPrimary',
        teamColorTwo: 'Team.teamColorSecondary',
        playerImage: getters.hasHeadshotPermission ? 'images.playerHeadshot' : false,
      },
    };
  },
  unstyledData(state, getters) {
    return {
      player: [
        {
          type: 'text',
          path: 'Player.fullName',
          settings: {
            name: 'Player Name',
          },
        },
        ...getters.hasLogoPermission ? [{
          type: 'image',
          path: 'images.teamLogo',
          settings: {
            name: 'Team Logo',
            imageUrl: `${TGB_ASSETS_URL}/logos/tagboard-hash-blue.svg`, // fallback
          },
          styles: {
            height: 100,
            width: 100,
          },
        }] : [],
        ...getters.hasHeadshotPermission ? [{
          type: 'image',
          path: 'images.playerHeadshot',
          settings: {
            name: 'Player Headshot',
            imageUrl: `${TGB_ASSETS_URL}/placeholders/person-silhouette.svg`, // fallback
          },
          styles: {
            height: 500,
            width: 500,
          },
        }] : [],
      ],
      team: [
        {
          type: 'text',
          path: 'Team.teamName',
          settings: {
            name: 'Team Name',
          },
        },
        ...getters.hasLogoPermission ? [{
          type: 'image',
          path: 'images.teamLogo',
          settings: {
            name: 'Team Logo',
            imageUrl: `${TGB_ASSETS_URL}/logos/tagboard-hash-blue.svg`, // fallback
          },
          styles: {
            height: 100,
            width: 100,
          },
        }] : [],
      ],
    };
  },
};
const mutations = {
  ...sharedSportradar.mutations,
};
const actions = {
  ...sharedSportradar.actions,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
